import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClipBoardService {
  copy(text: string) {
    return navigator.clipboard?.writeText(text);
  }
}
